import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ForgotPasswordComponent } from './forgot-reset-password/forgot-reset-password.component';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { OnBoardingComponent } from './on-boarding/on-boarding.component';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BsDropdownModule } from "ngx-bootstrap";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { BusinessFieldModalComponent } from 'src/app/components/auth/on-boarding/business-field-modal/business-field-modal.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { NumericDirective } from 'src/app/shared/directives/numeric.directive';
import { TermsCondtionsComponent } from './terms-condtions/terms-condtions.component';
import { UserConfirmedComponent } from './user-confirmed/user-confirmed.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SocialLoginModule, AuthServiceConfig } from "angularx-social-login";
import { FacebookLoginProvider } from "angularx-social-login";
let config = new AuthServiceConfig([
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider("396978771267817")
  }
]);
export function provideConfig() {
  return config;
}
@NgModule({
  declarations: [
    ForgotPasswordComponent,
    LoginComponent,
    SignUpComponent,
    OnBoardingComponent,
    BusinessFieldModalComponent,
    NumericDirective,
    TermsCondtionsComponent,
    UserConfirmedComponent,
    DisclaimerComponent,
    PrivacyPolicyComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    NgxIntlTelInputModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    AngularMultiSelectModule,
    SharedModule,
    CarouselModule,
    RouterModule,
    SocialLoginModule
  ],
  entryComponents: [
    LoginComponent,
    ForgotPasswordComponent,
    SignUpComponent,
    OnBoardingComponent,
    BusinessFieldModalComponent,
    TermsCondtionsComponent,
    UserConfirmedComponent,
    DisclaimerComponent,
    PrivacyPolicyComponent
  ],
  providers: [
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig
    }
  ]
})

export class AuthModule { }
